import React, { useRef } from "react";
import {
  Table,
  Input,
  TimePicker,
  InputNumber,
  Checkbox,
  Button,
  Space,
  message,
  Select,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";

class Rendertable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 4, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const employeeSalarylist = [...this.props.List];
    // const details = [...this.props.details];

    const { Option } = Select;

    // console.log("report render table");
    // console.log(employeeSalarylist);

    const columns = [
      // {
      //   title: 'SL.',
      //   key: 'index',
      //   render :(text, record, index) => index+1,
      // },
      {
        title: "Department",
        dataIndex: "department_name",
        key: "department_name",
        // ...this.getColumnSearchProps("employeeDepartment"),
      },
      {
        title: "Gross salary before",
        dataIndex: "total_gross_salary_before",
        key: "total_gross_salary_before",
        align: "right",
        // ...this.getColumnSearchProps("employeeId"),
      },
      {
        title: "Gross salary After",
        dataIndex: "total_gross_salary_after",
        key: "total_gross_salary_after",
        align: "right",
        // ...this.getColumnSearchProps("employeeName"),
      },
      {
        title: "Absent payment",
        dataIndex: "total_absent_payment",
        align: "right",
        key: "total_absent_payment",
        // ...this.getColumnSearchProps("employeeRole"),
      },
      {
        title: "Gross salary after deduction",
        dataIndex: "total_gross_salary_after_deduction",
        align: "right",
        key: "total_gross_salary_after_deduction",
        // ...this.getColumnSearchProps("Basicsalary"),
      },
      {
        title: "Overtime",
        dataIndex: "total_overtime",
        key: "total_overtime",
        align: "right"
      },
      {
        title: "Overtime payment",
        dataIndex: "toal_overtime_payment",
        key: "toal_overtime_payment",
        align: "right"
      },
      {
        title: "Net salary",
        dataIndex: "total_net_salary",
        key: "total_net_salary",
        align: "right"
      },


    ];

    return (
      <div>
        <Table columns={columns} dataSource={employeeSalarylist} size="small" pagination={false} />
      </div>
    );
  }
}

export default Rendertable;
